import EventDetails from "./eventDetails";

export default EventDetails;
